/**
  Description:
  still needs variables selectAll, and selected: [] in parent component
**/
export var isSuperAdmin = {
  methods: {
    isSuperAdmin () {
      return true
      // return parseInt(window.localStorage.permission) === 4
    }
  } // methods
} // checkAll
